import { domain } from 'modules/data';

import { NetSuiteExpenseLineExtendedExpenseReport } from '../../../data/types';

export const getLineCurrencyPrecision = (
    line: NetSuiteExpenseLineExtendedExpenseReport,
    currencies: domain.NetSuiteCurrency[]
) => currencies.find(({ id }) => id === line.currency?.id)?.precision ?? 2;
